import React from 'react';
import clsx from 'clsx';
import EllipsisTooltip from 'Components/EllipsisTooltip';
import styles from './PageHeaderTitle.css';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
    title: string;
    dataTestId: string;
}

const PageHeaderTitle = ({ className, title, dataTestId }: Props) => {
    return (
        <div className={clsx(styles.titleText, className)} data-testid={dataTestId}>
            <EllipsisTooltip text={title} className={styles.ellipText} defaultCursor />
        </div>
    );
};

export default PageHeaderTitle;
